module.exports = __webpack_public_path__ + "img/right-icon.455219d6.svg";